import { render } from "./MicroCampaign.vue?vue&type=template&id=420b13dc&scoped=true"
import script from "./MicroCampaign.vue?vue&type=script&lang=js"
export * from "./MicroCampaign.vue?vue&type=script&lang=js"

import "./MicroCampaign.vue?vue&type=style&index=0&id=420b13dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-420b13dc"]])

export default __exports__